import { render, staticRenderFns } from "./MenuEntryView.vue?vue&type=template&id=2d6a25dc&"
import script from "./MenuEntryView.vue?vue&type=script&lang=js&"
export * from "./MenuEntryView.vue?vue&type=script&lang=js&"
import style0 from "./MenuEntryView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports